import type { EmployeeStatus } from '@repo/types';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: EmployeeStatus;
  className?: string;
}

const statusConfig: Record<EmployeeStatus, { label: string; dot: string; className: string }> = {
  active: {
    label: 'Active',
    dot: 'bg-emerald-500',
    className: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  },
  inactive: {
    label: 'Inactive',
    dot: 'bg-muted-foreground/50',
    className: 'border-border bg-muted text-muted-foreground',
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.inactive;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        config.className,
        className
      )}
    >
      <span className={cn('size-1.5 rounded-full', config.dot)} />
      {config.label}
    </span>
  );
}
